<table
  mat-table
  [dataSource]="dataSource"
  class="mat-elevation-z1"
  multiTemplateDataRows
  matSort
  (matSortChange)="onSortChange($event)"
>
  <ng-container
    *ngFor="let column of additionalColumns; trackBy: additionalColumnTrackBy"
    [matColumnDef]="column.columnDef"
  >
    <ng-container *ngIf="column.sortable; else notSortableColumn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="flex hcenter">
          {{ column.header | async }}
        </div>
      </th>
    </ng-container>
    <ng-template #notSortableColumn>
      <th mat-header-cell *matHeaderCellDef>
        <div class="flex hcenter">
          {{ column.header | async }}
        </div>
      </th>
    </ng-template>
    <td mat-cell *matCellDef="let element">
      <div class="flex hcenter">
        <ng-container
          [ngComponentOutlet]="column.cell"
          [ngComponentOutletInjector]="getAdditionalColumnContext(element)"
        ></ng-container>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="payee_case_reference_id">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      {{ "CASES_TABLE.HEADERS.CASE_ID" | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.payee_case_reference_id }}
    </td>
  </ng-container>

  <ng-container matColumnDef="started_at">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      {{ "CASES_TABLE.HEADERS.STARTED_AT" | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <div class="case-started-at-box">
        {{ element.started_at | date : "yyyy.MM.dd. HH:mm:ss" }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="parties">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      {{ "CASES_TABLE.HEADERS.PARTIES" | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <div class="client">{{ element.parties.client_name }} vs</div>
      <div>
        <strong>{{ element.parties.debtor_name }}</strong>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="state">
    <th mat-header-cell *matHeaderCellDef>
      {{ "CASES_TABLE.HEADERS.STATE" | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <div class="status-box">
        <div
          class="state"
          [style.color]="element.state.state_label_text_color"
          [style.background-color]="element.state.state_label_background_color"
        >
          {{ element.state.state_label }}
        </div>
        <div class="stage">
          <span class="label">{{ element.state.stage_label }}</span>
        </div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="jurisdiction">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      {{ element.jurisdiction | countryFlag }}
    </td>
  </ng-container>

  <ng-container matColumnDef="partner">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <payee-icon
        *ngIf="getPartnerLogoName(element.partner?.integration)"
        height="24px"
        [name]="getPartnerLogoName(element.partner?.integration)"
      ></payee-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="remaining_claim">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      {{ "CASES_TABLE.HEADERS.REMAINING_CLAIMS" | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <div class="claims-sum-amount-box">
        <ng-container *ngFor="let currency of element.claim | keyvalue; let i = index">
          <ng-container *ngIf="i < 2">
            <div class="currency-amount">
              <span class="current">
                {{ currency.value.remaining_amount | number : "1.0" : "hu" }}
                {{ currency.key }}
              </span>
            </div>
          </ng-container>
        </ng-container>
        <span *ngIf="(element.claim | keyvalue).length > 2" class="more-currencies">
          {{ "CASES_TABLE.MORE_CURRENCIES" | translate:{count: (element.claim | keyvalue).length - 2} }}
        </span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="original_claim">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      {{ "CASES_TABLE.HEADERS.ORIGINAL_CLAIMS" | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <div class="claims-sum-amount-box">
        <ng-container *ngFor="let currency of element.claim | keyvalue; let i = index">
          <ng-container *ngIf="i < 2">
            <div class="currency-amount">
              <span class="original">
                {{ currency.value.original_amount | number : "1.0" : "hu" }}
                {{ currency.key }}
              </span>
            </div>
          </ng-container>
        </ng-container>
        <span *ngIf="(element.claim | keyvalue).length > 2" class="more-currencies">
          {{ "CASES_TABLE.MORE_CURRENCIES" | translate:{count: (element.claim | keyvalue).length - 2} }}
        </span>
      </div>
    </td>
  </ng-container>

  <!-- <ng-container matColumnDef="last_event">
    <th mat-header-cell *matHeaderCellDef>
      {{ "CASES_TABLE.HEADERS.LAST_EVENT" | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <span class="last-transition">
        {{ element.last_transition.label }}
      </span>
    </td>
  </ng-container> -->

  <!-- <ng-container matColumnDef="deadlines">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      {{ "CASES_TABLE.HEADERS.DEADLINE" | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <div class="deadlines-box flex column hcenter">
        <div class="hard-deadline" *ngIf="element.deadlines.hard">
          {{ element.deadlines.hard | date : "yyyy.MM.dd. HH:mm:ss" }}
        </div>
        <div class="soft-deadline" *ngIf="element.deadlines.soft">
          {{ element.deadlines.soft | date : "yyyy.MM.dd. HH:mm:ss" }}
        </div>
      </div>
    </td>
  </ng-container> -->

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <button
        payee-icon-button
        [matMenuTriggerFor]="actionsMenu"
        (menuOpened)="onActionsMenuOpen()"
        (menuClosed)="onActionsMenuClosed()"
        class="actions-menu-button"
        color="white"
      >
        <payee-icon [name]="environment.MORE_ICON"></payee-icon>
      </button>

      <mat-menu #actionsMenu>
        <ng-container *ngFor="let action of additionalActions">
          <button
            *ngIf="action.show(element)"
            mat-menu-item
            (click)="action.onClick(element)"
          >
            {{ action.label | async }}
          </button>
        </ng-container>
        <button
          *ngIf="element.is_editable && allowEdit"
          mat-menu-item
          (click)="editCase(element)"
        >
          {{ "CASES_TABLE.CASE_ACTIONS.EDIT" | translate }}
        </button>
        <button
          *ngIf="element.is_deletable && allowDelete"
          mat-menu-item
          (click)="deleteCase(element)"
        >
          {{ "CASES_TABLE.CASE_ACTIONS.DELETE" | translate }}
        </button>
        <button
          mat-menu-item
          *ngFor="let event of element.actions"
          (click)="runTransitionWithDialog(element, event)"
        >
          {{ event.label }}
        </button>
        <button
          mat-menu-item
          *ngIf="
            element.actions.length === 0 &&
            !element.is_deletable &&
            !element.is_editable
          "
        >
          {{ "CASES_TABLE.CASE_ACTIONS.NO_ACTIONS" | translate }}
        </button>
      </mat-menu>
    </td>
  </ng-container>

  <ng-container matColumnDef="detailsToggle">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <payee-icon name="arrow-down-grey-no-shaft"></payee-icon>
    </td>
  </ng-container>

  <!-- Expanded Content Column -->
  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="displayedColumns.length"
    >
      <div
        class="element-detail alt-theme flex column grow1"
        [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"
      >
        <mat-tab-group dynamicHeight>
          <mat-tab *ngIf="element === expandedElement" label="Események">
            <app-case-events [caseId]="element.id"></app-case-events>
          </mat-tab>
          <mat-tab *ngIf="element === expandedElement" label="Részletek">
            <app-case-details
              [caseId]="element.id"
              (filterCase)="filterHistoricCase($event)"
            ></app-case-details>
          </mat-tab>
        </mat-tab-group>
      </div>
    </td>
  </ng-container>

  <tr
    *matHeaderRowDef="displayedColumns"
    mat-header-row
    class="main-header"
  ></tr>
  <tr
    *matRowDef="let element; columns: displayedColumns"
    mat-row
    class="element-row mat-elevation-z2"
    [class.expanded-row]="expandedElement === element"
    (click)="updateExpandedElement(element)"
  ></tr>
  <tr
    *matRowDef="let row; columns: ['expandedDetail']"
    mat-row
    class="detail-row"
  ></tr>
</table>
